export const DisplayState = {
  Opened: 'opened',
  Closed: 'closed',
};

export const ModalPositionType = {
  Right: 'right',
  Center: 'center',
  Left: 'left',
};

export const ModalViewType = {
  FullWidth: 'full-width',
  FitContent: 'fit-content',
};

export const ModalSlotName = {
  Header: 'header',
  Content: 'content',
  Footer: 'footer',
};
